export default __webpack_public_path__ + "static/inside-track-689a066cd0a058d7cf253f63536347e4.jpg";